import React, {useMemo} from 'react';
import PopupMenuActions from '../../../../../components/shared/popup-menu';
import {PopupMenuAction} from '../../../../../components/shared/popup-menu/types';
import {SVGS} from '../../../../../assets/images';

type Props = {
    actions: Array<PopupMenuAction | undefined>;
    disabled?: boolean;
};

const TimesheetActionsMenu: React.FC<Props> = ({ actions, disabled }) => {
    const availableActions = useMemo(
        () => actions.filter((action): action is PopupMenuAction => !!action),
        [actions]
    );

    return (
        <PopupMenuActions
            actionIcon={<SVGS.ActionIcon />}
            actions={availableActions}
            size='small'
            newGen
            //variant='bare'
            disabled={disabled || availableActions.length === 0}
        />
    );
};

export default TimesheetActionsMenu;
